/*
 * @Author: 南枫
 * @Date: 2020-12-02 10:15:06
 * @LastEditors: 南枫
 * @LastEditTime: 2021-08-19 10:01:37
 */
// 时间戳转时间
function add0(m) {
    return m < 10 ? '0' + m : m
}
export function timestampFormat(timestamp) {
    var time = new Date(timestamp * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}
export function checkPhone(phone) {
    if (!/^1[3|4|5|7|8|9]\d{9}$/.test(phone)) {
        return false;
    } else {
        return true;
    }
}
//判断微信环境
export function isWeiXin() {
    var ua = navigator.userAgent.toLowerCase();
    let isWx = ua.match(/MicroMessenger/i) == "micromessenger";
    if (isWx) {
        let isWxWork = ua.match(/WxWork/i) == "wxwork";
        if (!isWxWork) {
            // 微信内浏览器
            return 'wx';
        } else {
            // 企业微信浏览器
            return 'wxwork';
        }
    } else {
        // web浏览器
        return false;

    }
}

/**
 * 金额格式化（2位小数）
 * @param {value}} 输入的金额字符 
 */
export function clearNoNum(value) {
    value = String(value);
    value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
    value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
    value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    if (value.indexOf(".") < 0 && value != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
    }
    return value;
}

/**
 * 列表数据处理
 * @param {page, limit, list}} 
 */
export function setListData(data = [], list = [], page = 1, limit = 10) {
    let no_data = false,
        no_more = false,
        finish = false,
        new_list = []
    if (page == 1) {
        new_list = data
    } else {
        new_list = list.concat(data)
    }
    // 是否还有更多
    if (data.length < limit) {
        no_more = true
        finish = true
    }
    // 是否存在数据
    if (!new_list.length) {
        no_data = true
        no_more = false
    }
    return {
        list: new_list,
        no_more,
        no_data,
        finish
    };
}

export function unique(arr) {
    return Array.from(new Set(arr));
}

export function isEmpty(value) {
    if (typeof value === 'object' && Object.values(value).length < 1) {
        return true;
    }
    if (typeof value === 'undefined' || value === null || value === '') {
        return true;
    }
    return false;
}

// 防抖函数
export const debounce = (fn, delay = 1000) => {
    let timerId = null;
    return function(...args) {
        timerId && clearTimeout(timerId);
        timerId = setTimeout(() => {
            fn.apply(this, args); // 把参数传进去
        }, delay);
    };
}